<template>
  <div class="grid-container sm:justify-center">
    <Head title="¿Olvidaste tu contraseña?"></Head>
    <div
      class="flex flex-col justify-center gap-4 w-full pt-6 md:pt-14 sm:col-[4_/_-4] md:col-[5_/_-5] xl:col-[4_/_-4]"
    >
      <div class="flex justify-end">
        <Link :href="$route('login')">
          <Button icon="arrow-back" class="btn-tonal">Regresar</Button>
        </Link>
      </div>
      <div class="md:mx-12">
        <div v-if="emailSent">
          <h1 class="headline-md pb-2 text-brand-dark-green">📨 ¡Correo enviado!</h1>
          <p class="title-md text-neutral40">
            Hemos enviado las instrucciones para restablecer tu contraseña a tu correo.
          </p>
        </div>
        <div v-else>
          <header>
            <h1 class="headline-md pb-2">¿Olvidaste tu contraseña?</h1>
            <p class="title-md text-neutral40">
              Ingresa tu correo electrónico y te enviaremos instrucciones para restablecer tu
              contraseña
            </p>
          </header>
          <form class="my-2" @submit.prevent="submit">
            <FormInputText
              v-model="form.email"
              type="email"
              label="Correo electrónico"
              placeholder="example@email.com"
              required
              :error="errors.errors"
            />
            <Button
              type="submit"
              class="btn-filled mx-auto block my-2"
              :isLoading="form.processing"
            >
              Enviar
            </Button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Layout from '@/Layouts/Layout'
import { Head, Link } from '@inertiajs/inertia-vue'
import Button from '@/Components/Button'
import FormInputText from '@/Components/FormInputText'

export default {
  name: 'ForgotPassword',
  layout: Layout,
  components: { Head, Link, Button, FormInputText },
  props: {
    errors: {
      type: Object,
      default: {},
    },
    emailSent: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: this.$inertia.form({
        email: '',
      }),
    }
  },
  methods: {
    submit() {
      this.form.post(this.$route('password.email'), {
        preserveState: false,
        onError: errors => {
          this.$swal.fire({
            title: '¡Ocurrió un error!',
            text: 'Por favor, revisa los datos e intenta de nuevo.',
          })
        },
      })
    },
  },
}
</script>
